import React from 'react';
import { connect } from 'react-redux';
import './SubtopicsMenu.css';
import { changeSubtopic } from '../../../../redux/actions';
import { SUBTOPIC_ALL } from '../../../../constants';

// todo - probably move to components - and handle redux stuff in page element
const SubtopicsMenu = ({ actualSubtopic, visibleData, switchSubtopic }) => {
  const subtopics = [SUBTOPIC_ALL];
  visibleData.forEach((item) => {
    item[1].subtopic.forEach((subtopic) => {
      if (subtopic.length > 0 && subtopics.indexOf(subtopic) === -1) {
        subtopics.push(subtopic);
      }
    });
  });

  // create elements
  const subtopicElements = subtopics.map((subtopic) => {
    let btnClass = 'subtopic';
    if (subtopic === actualSubtopic) {
      btnClass = `${btnClass} selected`;
    }
    return (
      <button
        key={encodeURIComponent(subtopic)}
        className={btnClass}
        onClick={() => switchSubtopic(subtopic)}
      >
        {subtopic}
      </button>
    );
  });

  // try to hide menu
  let menuClass = 'subtopic-menu';
  if (subtopics.length === 1) {
    menuClass = `${menuClass} disabled`;
  }

  return (
    <div id="subtopic-menu" className={menuClass}>
      {subtopicElements}
    </div>
  );
};

const mapStateToProps = state => ({
  actualSubtopic: state.dataCategory.subtopic,
  visibleData: state.dataCategory.visibleData,
});

const mapDispatchToProps = dispatch => ({
  switchSubtopic: subtopic => dispatch(changeSubtopic(subtopic)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubtopicsMenu);



// WEBPACK FOOTER //
// ./src/components/App/CategoryPage/SubtopicsMenu/SubtopicsMenu.js